package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.kunde.kundenportal2.components.inlineLink
import de.oevbs.kunde.kundenportal2.components.paragraph
import de.oevbs.kunde.kundenportal2.services.contract.detailsSection
import dev.fritz2.core.RenderContext


/**
 * Vertragsdetails für die Rechtsschutzverträge
 * Details werden von den Kooperationspartnern gepflegt. Daher der Verweis für den Kunden.
 */
fun RenderContext.contractDetailsLegalExpense() {
    detailsSection("Ihr Versicherungsschutz") {
        paragraph {
            p {
                +"""Weitere Informationen zu Ihrem Vertrag und zum Thema Rechtsschutz erhalten Sie bei unserem 
                | Kooperationspartner.""".trimMargin()
            }
            p { +"Ihren Ansprechpartner finden Sie auf dem Versicherungsschein." }
        }
        div("flex flex-col lg:flex-row flex-1 gap-2") {
            div {
                h4("vui-label-3") { +"Roland Rechtsschutz" }
                ul {
                    li {
                        +"Internet: "
                        inlineLink(
                            text = "https://www.roland-rechtsschutz.de",
                            link = "https://www.roland-rechtsschutz.de",
                            target = "_blank"
                        )
                    }
                    li {
                        +"Mail: "
                        inlineLink(
                            text = "service@roland-rechtsschutz.de",
                            link = "mailto:service@roland-rechtsschutz.de"
                        )
                    }
                }
            }
            div {
                h4("vui-label-3") { +"ÖRAG Rechtsschutzversicherung-AG" }
                ul {
                    li {
                        +"Internet: "
                        inlineLink(
                            text = "https://www.oerag.de",
                            link = "https://www.oerag.de",
                            target = "_blank"
                        )
                    }
                    li {
                        +"Mail: "
                        inlineLink(
                            text = "info@oerag.de",
                            link = "mailto:info@oerag.de"
                        )
                    }
                }
            }
        }
    }
}